import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@/shared/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css'],
  standalone: false,
})
export class LoginFormComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  // show password input
  public hide = true;
  public errorMessage: string = '';
  public showError: boolean = false;
  public loginAttemptsLeft: number = 3;
  public env = environment;

  // login form group
  public loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.loginForm.valueChanges.subscribe((_) => {
        this.showError = false;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // error message for email input if incorrect info was typed in
  getErrorMessage() {
    if (this.loginForm.hasError('required')) {
      return 'You must enter a value';
    }

    return this.loginForm.hasError('username') ? 'Not a valid username' : '';
  }

  submit(form: FormGroupDirective) {
    this.subscription.add(
      this.authService.login(form.value).subscribe({
        next: (user) => {
          const url = localStorage.getItem('prev_url');
          this.authService.saveToken(user?.token || '');
          this.router.navigateByUrl(url || 'home');
        },
        error: ({ error }) => {
          if (error.lock_minutes_remain) {
            this.errorMessage = `Your account is locked. Please try again in ${error.lock_minutes_remain} minutes`;
          }
          if (error.login_attempts_remain) {
            this.errorMessage = `Invalid credentials. You have ${error.login_attempts_remain} attempts remaining.`;
          }
          this.showError = true;
        },
      }),
    );
  }
}
